import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'getProductStatus' })
export class ProductStatusPipe implements PipeTransform {

    transform(value: number): string {

        if ( value == undefined || value == null ) {
            return '';
        }
        // console.log("getProductStatus Pipe - value passed = " + value);
        switch ( value ) {
            case 0:
                return 'Open';
            case 1:
                return 'Registered';
            case 2:
                return 'Cancelled (Registered)'; // Cancelled
            case 3:
                return 'Cancelled (Open)';
            case 4:
                return 'Disabled';
            case 5:
                return 'Transferred';
            case 99:
                return 'Cancelled'; // Terminated
            case 1000:
                return 'Active'; // Membership only
            default:
            return 'N/A'
        }

    }

}
